export default __webpack_public_path__ + "ac3231f83e4c5ec9495dde4ce2dccc94.png";